'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCmsData = exports.fetchProjects = exports.fetchContact = exports.fetchPublishing = exports.fetchTechnical = exports.fetchFooter = exports.fetchCreative = exports.fetchProject = exports.footerResult = exports.projectsResult = exports.contactResult = exports.publishingResult = exports.technicalResult = exports.creativeResult = exports.cmsResult = exports.cmsRequested = exports.cmsRequest = exports.FOOTER_RESULT = exports.PROJECTS_RESULT = exports.CONTACT_RESULT = exports.PUBLISHING_RESULT = exports.TECHNICAL_RESULT = exports.CREATIVE_RESULT = exports.CMS_RESULT = exports.CMS_REQUESTED = exports.CMS_REQUEST = undefined;

var _prismic = require('prismic.io');

var _prismic2 = _interopRequireDefault(_prismic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CMS_REQUEST = exports.CMS_REQUEST = 'CMS_REQUEST'; // import callAPI from './callAPI'
var CMS_REQUESTED = exports.CMS_REQUESTED = 'CMS_REQUESTED';
var CMS_RESULT = exports.CMS_RESULT = 'CMS_RESULT';
var CREATIVE_RESULT = exports.CREATIVE_RESULT = 'CREATIVE_RESULT';
var TECHNICAL_RESULT = exports.TECHNICAL_RESULT = 'TECHNICAL_RESULT';
var PUBLISHING_RESULT = exports.PUBLISHING_RESULT = 'PUBLISHING_RESULT';
var CONTACT_RESULT = exports.CONTACT_RESULT = 'CONTACT_RESULT';
var PROJECTS_RESULT = exports.PROJECTS_RESULT = 'PROJECTS_RESULT';
var FOOTER_RESULT = exports.FOOTER_RESULT = 'FOOTER_RESULT';

var apiURL = 'https://soundscape.cdn.prismic.io/api';

var cmsRequest = exports.cmsRequest = function cmsRequest() {
  return {
    type: CMS_REQUEST,
    loading: true
  };
};

var cmsRequested = exports.cmsRequested = function cmsRequested() {
  return {
    type: CMS_REQUESTED,
    loading: false
  };
};

var cmsResult = exports.cmsResult = function cmsResult(json) {
  return {
    type: CMS_RESULT,
    json: json,
    loading: false
  };
};

var creativeResult = exports.creativeResult = function creativeResult(json) {
  return {
    type: CREATIVE_RESULT,
    json: json,
    loading: false
  };
};

var technicalResult = exports.technicalResult = function technicalResult(json) {
  return {
    type: TECHNICAL_RESULT,
    json: json,
    loading: false
  };
};

var publishingResult = exports.publishingResult = function publishingResult(json) {
  return {
    type: PUBLISHING_RESULT,
    json: json,
    loading: false
  };
};

var contactResult = exports.contactResult = function contactResult(json) {
  return {
    type: CONTACT_RESULT,
    json: json,
    loading: false
  };
};

var projectsResult = exports.projectsResult = function projectsResult(json) {
  return {
    type: PROJECTS_RESULT,
    json: json,
    loading: false
  };
};

var footerResult = exports.footerResult = function footerResult(json) {
  return {
    type: FOOTER_RESULT,
    json: json,
    loading: false
  };
};

var fetchProject = exports.fetchProject = function fetchProject(slug) {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.getByUID('project', slug).then(function (response) {
        dispatch(cmsResult(response));
      });
    });
  };
};

var fetchCreative = exports.fetchCreative = function fetchCreative() {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.query(_prismic2.default.Predicates.at('document.type', 'creative')).then(function (response) {
        dispatch(creativeResult(response.results));
      });
    });
  };
};

var fetchFooter = exports.fetchFooter = function fetchFooter() {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.query(_prismic2.default.Predicates.at('document.type', 'footer')).then(function (response) {
        dispatch(footerResult(response.results));
      });
    });
  };
};

var fetchTechnical = exports.fetchTechnical = function fetchTechnical() {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.query(_prismic2.default.Predicates.at('document.type', 'technical')).then(function (response) {
        dispatch(technicalResult(response.results));
      });
    });
  };
};

var fetchPublishing = exports.fetchPublishing = function fetchPublishing() {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.query(_prismic2.default.Predicates.at('document.type', 'publishing')).then(function (response) {
        dispatch(publishingResult(response.results));
      });
    });
  };
};

var fetchContact = exports.fetchContact = function fetchContact() {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.query(_prismic2.default.Predicates.at('document.type', 'contact')).then(function (response) {
        dispatch(contactResult(response.results));
      });
    });
  };
};

var fetchProjects = exports.fetchProjects = function fetchProjects() {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      api.query(_prismic2.default.Predicates.at('document.type', 'project')).then(function (response) {
        dispatch(projectsResult(response.results));
      });
    });
  };
};

var fetchCmsData = exports.fetchCmsData = function fetchCmsData(type, item, options) {
  return function (dispatch) {
    dispatch(cmsRequest());

    _prismic2.default.api(apiURL, function (error, api) {
      if (!type) {
        api.query('', options, function (error, response) {
          if (error) {
            console.log('Something went wrong: ', error);
          }
          dispatch(cmsResult(response));
        });
      } else {
        api.query(_prismic2.default.Predicates.at(type, item), options).then(function (response) {
          dispatch(cmsResult(response.results));
        });
      }
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/actions/cms.js
// module id = 19
// module chunks = 1